import React from 'react';
import ReactDOM from 'react-dom';
import Main from './index/main.js';
import { LocaleProvider } from 'antd';
import { HashRouter, Route } from 'react-router-dom';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import "./font/iconfont.css";

import "./assets/index.css";
import "./assets/style.css";
import "./assets/theme.css";
import menuList from './index/menulist.js';
import common from './assets/common.js';

import "console-polyfill";
import "isomorphic-fetch";
import "fetch-detector";
import "eventsource-polyfill";
import "fetch-ie8";

import "babel-polyfill";
import "babel-plugin-transform-runtime";

class Content extends React.Component {
  componentWillMount(){
    // var b_version=navigator.appVersion;
    // var version = parseFloat(b_version)
    // switch(navigator.appName){
    //   case "Microsoft Internet Explorer":
    //     if(version >= 5){
    //       common.setCookie("navi", true);
    //     } else {
    //       common.setCookie("navi", false);
    //       window.location.href = "#/compatible";
    //     }
    //     break;
    //   case "Netscape":
    //     if(version >= 11){
    //       common.setCookie("navi", true);
    //     } else {
    //       common.setCookie("navi", false);
    //       window.location.href = "#/compatible";
    //     }
    //     break;
    //   default:
    //     common.setCookie("navi", false);
    //     window.location.href = "#/compatible";
    //     break;
    // }
    window.addEventListener('hashchange', function () {
      const key = window.location.hash.split("#")[1].split("?")[0];
      const keymenu = common.lookUpTree(menuList.list, 'sub', 'key', key);
      if(keymenu.length === 0){
        if(window.info){
          switch(window.info.adminRoles){
            case "":
              break;
            case "SUBADMIN":
              window.location.href = "#/product";
              break;
            default:
              window.location.href = "#" + menuList.default;
              break;
          }
        } else {
          window.location.href = "#/login";
        }
      }
    });
  }
  render(){
    return (
      <LocaleProvider locale={zhCN}>
        <HashRouter forceRefresh={true}>
          <Route path={ '/' } component={ Main }/>
        </HashRouter>
      </LocaleProvider>
    )
  }
}
ReactDOM.render(<Content />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js